import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Youtube, Music2, Mail, Phone, MapPin } from "lucide-react";
import { useI18n } from "../../i18n";
import { useSettings } from "../../context/SettingsContext";
import { LOGO_URL } from "../../lib/api";
import { Container } from "../ui-kit";

const COLS = [
  ["Explore", [["About", "/about"], ["Programs", "/programs"], ["Impact", "/impact"], ["CSR", "/csr"], ["Technology", "/technology"], ["Islamic Giving", "/islamic-giving"], ["Contact", "/contact"]]],
  ["Resources", [["Media & Stories", "/media"], ["Reports", "/impact#reports"], ["FAQs", "/islamic-giving#faqs"], ["Zakat Calculator", "/zakat-calculator"]]],
  ["Trust", [["Transparency", "/transparency"], ["Policies", "/legal"], ["Privacy", "/legal#privacy"], ["Responsible Giving", "/legal#responsible-giving"], ["Complaints", "/legal#complaints"]]],
];

export default function Footer() {
  const { t } = useI18n();
  const { settings } = useSettings();
  const social = settings?.social_links || {};

  return (
    <footer className="islamic-pattern text-emerald-50">
      <Container className="py-16">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Helping Hands" className="h-14 w-14 rounded-full object-cover ring-1 ring-gold/40" />
              <div className="font-display text-2xl font-bold">Helping Hands</div>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-emerald-100/70">{t("footer_tagline")}</p>
            <p className="mt-3 text-xs font-semibold text-gold-light">Helping Hands Global Solutions - FZCO</p>
            <div className="mt-6 space-y-2 text-sm text-emerald-100/70">
              <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-gold-light" /> {settings?.address || "Dubai, United Arab Emirates"}</div>
              <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-gold-light" /> {settings?.email}</div>
              <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-gold-light" /> {settings?.phone}</div>
            </div>
            <div className="mt-6 flex gap-3">
              {[[Instagram, social.instagram], [Facebook, social.facebook], [Linkedin, social.linkedin], [Youtube, social.youtube], [Music2, social.tiktok]].map(([Icon, url], i) => (
                url ? <a key={i} href={url} target="_blank" rel="noreferrer" className="rounded-full border border-emerald-100/20 p-2 transition hover:border-gold hover:text-gold"><Icon className="h-4 w-4" /></a> : null
              ))}
            </div>
          </div>
          {COLS.map(([title, links]) => (
            <div key={title}>
              <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-gold-light">{title}</h4>
              <ul className="mt-4 space-y-2.5">
                {links.map(([label, to]) => (
                  <li key={label}><Link to={to} className="text-sm text-emerald-100/70 transition hover:text-white">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 border-t border-emerald-100/15 pt-6 text-xs text-emerald-100/60">
          <p className="max-w-3xl leading-relaxed">
            Helping Hands is operated by Helping Hands Global Solutions - FZCO, Dubai, United Arab Emirates. We support legitimate CSR initiatives and authorised campaigns through trusted partners. Tax treatment may vary by jurisdiction. Please consult your local tax adviser.
          </p>
          <div className="mt-4 flex flex-col justify-between gap-2 sm:flex-row">
            <span>© {new Date().getFullYear()} Helping Hands Global Solutions - FZCO. All Rights Reserved.</span>
            <div className="flex gap-4">
              <Link to="/legal" className="hover:text-white">Legal Centre</Link>
              <Link to="/transparency" className="hover:text-white">Transparency</Link>
              <Link to="/admin" className="hover:text-white">Admin</Link>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
}
